import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
  	strict: process.env.NODE_ENV !== 'production',

  	pledgeCompleted: false,
    totalResources: 0,
    
  	newUser: {
	    id: '',
	    name: '',
	    email: '',
	    pic: '',
      location: {
        city: '',
        country: '',
        code: ''
      }
	  },

	  wasReferred: false,
	  referralUser: {
	  	name: '',
	  	pic: ''
	  },

    showModal : false,

    year: new Date().getUTCFullYear()
  },

  actions: {

  },

  mutations: {

  },

  getters: {

  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js